<template>
    <RedesignFormItem :label="t('layout.config.widgetTableContentFontSize')">
        <vc-input-number
            v-model="model"
            :max-value="optionConfigs.WidgetTableContentFontSize.max"
            :min-value="optionConfigs.WidgetTableContentFontSize.min"
            :step="optionConfigs.WidgetTableContentFontSize.step"
            placeholder="0"
        />
    </RedesignFormItem>
</template>

<script setup lang="ts">
import RedesignFormItem from '@/components/RedesignBaseComponents/Form/RedesignFormItem.vue'
import { computed } from 'vue'
import { optionConfigs } from '@/views/DashboardSettings/LayoutManagement/layout-management'
import { widgetTableContentFontSize } from '@/composables/globalData/useLayouts'
import { VcInputNumber } from '@voicenter-team/voicenter-ui-plus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
    modelValue?: string
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()

const model = computed({
    get () {
        return stringValueToNumber(stringValue.value)
    },
    set (val) {
        emit('update:modelValue', numberValueToString(val))
    }
})


const hasOwnValue = computed(() => {
    return props.modelValue !== undefined
})

const layoutConfig = computed(() => {
    return widgetTableContentFontSize.value
})

const stringValue = computed(() => {
    if (hasOwnValue.value) {
        return props.modelValue || ''
    } else {
        return layoutConfig.value?.fontSize
    }
})

/* Methods */
function stringValueToNumber (value: string) {
    return parseInt(value.replace('px', ''))
}
function numberValueToString (value: number) {
    return `${value}px`
}
</script>

